import { createFileRoute } from "@tanstack/react-router";
import { PageHero, PageIntro } from "@/components/site/PageHero";
import { PhonePlans } from "@/components/site/PhonePlans";
import { Reveal } from "@/components/site/Reveal";
import { Section } from "@/components/site/Section";
import { whatsappLink } from "@/content/site";
import { useSiteSection } from "@/hooks/useSiteContent";

export const Route = createFileRoute("/telefonia")({
  head: () => ({
    meta: [
      { title: "Planos de telefonia Fale Mais | Contato Internet" },
      {
        name: "description",
        content:
          "Telefonia fixa e móvel da Contato: planos Fale Mais em combo com a internet, portabilidade do seu número e ligações ilimitadas.",
      },
      { property: "og:title", content: "Planos de telefonia Fale Mais — Contato" },
      {
        property: "og:description",
        content: "Combo de telefonia com internet, portabilidade e ligações ilimitadas.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: TelefoniaPage,
});

function TelefoniaPage() {
  const phone = useSiteSection("phone");
  return (
    <>
      <PageHero eyebrow={phone.eyebrow} title={phone.title} subtitle={phone.subtitle} />
      <PageIntro text={phone.text} />

      <Reveal variant="fade-up">
        <PhonePlans hideHeader />
      </Reveal>

      <Section reveal title="Ficou com dúvida sobre qual plano combina com você?">
        <div className="text-center">
          <a
            href={whatsappLink("Olá! Quero ajuda para escolher um plano de telefonia da Contato.")}
            target="_blank"
            rel="noreferrer"
            className="inline-flex rounded-full bg-brand-yellow px-8 py-3.5 text-sm font-extrabold uppercase tracking-wide text-brand-yellow-foreground transition-transform hover:-translate-y-0.5"
          >
            Falar com a Contato
          </a>
        </div>
      </Section>
    </>
  );
}
